export default "__VITE_ASSET__DyUKzcxz__"